import axios from "utils/axios"; 


/**
 * Отримуємо залишки по складу
 * @param {Number} warehouseId
 * @param {int} stockData.page
 * @param {string} stockData.search
 * @returns 
 */
export const getStocks = async (warehouseId, stockData) => {
    try {
        const response = await axios(`/warehouses/stocks/${warehouseId}`, {params:stockData});
        return response.data;
    } catch(error){
        console.log(error); 
        return null;
    }
} 

/**
 * Отримуємо масив ID товарів з позитивним залишком на складі
 * @param {*} warehouseId 
 */
export const getProductsInWarehouse = async (warehouseId) =>{
     try {
        const response = await axios(`/warehouses/stocks/allIds/${warehouseId}`);
        return response.data; 
    } catch(error){
        console.log(error);
        return null;
    }   
}

/**
 * Отримуємо залишок товару на складі в розрізі закупівельних цін
 * @param {Number} warehouseId
 * @param {Number} productId
 */ 
/**
 * Партії залишку для списку товарів одного складу
 * @param {Number} warehouseId
 * @param {number[]} productIds
 */
export const getStockLots = async (warehouseId, productIds) => {
    try {
        const response = await axios(`/warehouses/stocks/${warehouseId}/lots`, {
            params: { productIds: (productIds || []).join(',') },
        });
        return response.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getStockByProductId = async (warehouseId, productId) => {
    try {
        const response = await axios(`/warehouses/stocks/${warehouseId}/${productId}`);
        return response.data||null;
    } catch(e){
        console.error(e);
        return null;
    }
}


/**
 * Отримуємо рух товару по складу
 * @param {Number} warehouseId 
 * @param {Number} productId 
 * @param {Object} gData { page }
 * @returns 
 */
export const getOperations = async (warehouseId, productId, gData) => {
    try {
        const response = await axios(`/warehouses/operations/${warehouseId}/${productId}`, {params:gData});
        return response.data;
    } catch(e){
        console.log(e);
        return null;
    }
}

/**
 * Отримуємо повну інформацію про операцію
 * @param {Number} operationId 
 */
export const getOperationInfo = async (operationId) => {
    try {
        const response = await axios(`/warehouses/operations/${operationId}`);
        return response.data;
    } catch(e){
        console.error(e);
        return null;
    }
}


/**
 * Виконуємо прихід на склад
 * @param {Array} comingData [{ productId, count, price, priceSale, priceRate, pricaSaleRate }]
 * @returns 
 */ 
export const coming2MainWarehouse = async (comingData) => {
    try {
        const response = await axios.post('/warehouses/operations/coming', comingData);
        return response.data.stat||false;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Трансфер залишків з одного складу на інший
 * @param {Number} whFrom
 * @param {Number} whTo
 * @param {Array} comingData  [{ productId, count, price, priceSale, priceRate, pricaSaleRate }]
 */
export const transferBetweenWarehouses = async (whFrom, whTo, transferData) => {
    try {
        const response = await axios.post(`/warehouses/operations/transfer/${whFrom}/${whTo}`, transferData);
        return response.data;
    } catch(e){
        console.error(e);
        return false;
    }
}

 
/**
 * Повернення-скасування операції зі складу
 * @param {Number} warehouseId 
 * @param {Number} productId 
 */
export const reversalOperation = async (operationId) => {
    try {
        const response = await axios.post(`/warehouses/operations/reversal/${operationId}`);
        return response.data?.stat;
    } catch(e) {
        console.error(e);
        return false;
    }
}


/**
 * Змінює роздрібну ціну товару в операції складу
 * @param {Number} operationId 
 * @param {Object} priceData  { priveSale, priceSaleRate }
 * @returns 
 */ 
export const setPriceSale = async (operationId, priceData) =>{
    try {
        const response = await axios.post(`/warehouses/operations/price/sale/${operationId}`, priceData);
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Пакетне оновлення лише роздрібних цін на прихідних операціях складу
 * @param {Number} warehouseId
 * @param {Object} payload
 * @param {Array<{productId:number, priceSale:number, fromWarehouseId?:number, count?:number, description?:string}>} payload.items
 * @param {string} [payload.description]
 * @returns {Promise<{stat:boolean, updated:number, failed:number}|false>}
 */
export const setPriceSaleBatch = async (warehouseId, payload) => {
    try {
        const response = await axios.post(
            `/warehouses/operations/price/sale/batch/${warehouseId}`,
            payload,
        );
        return response.data;
    } catch (e) {
        console.error(e);
        return false;
    }
};

/**
 * Зміна опису операції
 * @param {Number} operationId 
 * @param {string} description 
 * @returns 
 */
export const setDescriptionOperation = async (operationId, description) =>{
    try {
        const response = await axios.post(`/warehouses/operations/description/${operationId}`, {description});
        return response.data.stat;
    } catch(e){
        console.error(e);
        return false;
    }
}

/**
 * Додавання оплати на склад
 * @param {Number} productId 
 * @param {PaymentData} paymentData 
 */
export const addPayment = async (warehouseId, productId, paymentData) => {
    try {
        const response = await axios.post(`/warehouses/operations/payment/${warehouseId}/${productId}`, paymentData);
        return {
            stat: response?.data?.stat || false,
            paymentId: Number(response?.data?.paymentId || 0),
        };
    } catch(e){
        console.error(e);
        return { stat: false, paymentId: 0 };
    }
}

/**
 * Повертає список оплат по товару
 * @param {Number} warehouseId 
 * @param {Number} productId 
 */
export const getPayments = async (warehouseId, productId) => {
    try {
        const response = await axios.get(`/warehouses/operations/payments/${warehouseId}/${productId}`);
        return response.data||null;
    } catch(e){
        console.error(e);
        return null;
    }
}

/**
 * Створення бригади зі складом
 * @param {string} teamName
 */
export const createTeam = async (teamName) => {
    try {
        const response = await axios.post('/warehouses/teams/create', { teamName: teamName });
        return response.data;
    } catch (e) {
        // axios interceptor повертає response.data напряму, не AxiosError
        if (e && typeof e === 'object' && ('stat' in e || 'errCode' in e)) {
            return e;
        }
        if (e?.response?.data) return e.response.data;
        console.error(e);
        return null;
    }
}

const handleTeamApiError = (e) => {
    if (e && typeof e === 'object' && ('stat' in e || 'errCode' in e)) {
        return e;
    }
    if (e?.response?.data) return e.response.data;
    console.error(e);
    return null;
}

export const renameTeam = async (teamId, teamName) => {
    try {
        const response = await axios.post(`/warehouses/teams/rename/${teamId}`, { teamName: teamName });
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}

export const moveTeamToTop = async (teamId) => {
    try {
        const response = await axios.post(`/warehouses/teams/move-top/${teamId}`);
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}

export const deleteTeam = async (teamId) => {
    try {
        const response = await axios.post(`/warehouses/teams/delete/${teamId}`);
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}

export const createCustomWarehouse = async (name) => {
    try {
        const response = await axios.post('/warehouses/custom/create', { name });
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}

export const renameCustomWarehouse = async (customId, name) => {
    try {
        const response = await axios.post(`/warehouses/custom/rename/${customId}`, { name });
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}

export const deleteCustomWarehouse = async (customId) => {
    try {
        const response = await axios.post(`/warehouses/custom/delete/${customId}`);
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}

export const getStockControlList = async (params) => {
    try {
        const response = await axios('/warehouses/stock-control', { params });
        return response.data;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export const getStockControlDetail = async (productId, params) => {
    try {
        const response = await axios(`/warehouses/stock-control/${productId}`, { params });
        return response.data;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export const getPendingIncome = async (warehouseId) => {
    try {
        const response = await axios(`/warehouses/pending/${warehouseId}`);
        return response.data;
    } catch (e) {
        console.error(e);
        return null;
    }
}

export const acceptPendingIncome = async (warehouseId, items) => {
    try {
        const response = await axios.post(`/warehouses/pending/${warehouseId}/accept`, { items });
        return response.data;
    } catch (e) {
        console.error(e);
        return { stat: false, errCode: 'UNKNOWN' };
    }
}

export const rejectPendingIncome = async (warehouseId, operationIds) => {
    try {
        const response = await axios.post(`/warehouses/pending/${warehouseId}/reject`, { operationIds });
        return response.data;
    } catch (e) {
        console.error(e);
        return { stat: false, errCode: 'UNKNOWN' };
    }
}

export const setWarehouseIdApi = async (warehouseId, warehouseIdApi) => {
    try {
        const response = await axios.post(`/warehouses/${warehouseId}/api-id`, {
            warehouseIdApi: warehouseIdApi ?? '',
        });
        return response.data;
    } catch (e) {
        return handleTeamApiError(e);
    }
}